// Setup cart actions and events
document.addEventListener("DOMContentLoaded", ()=>{

    const openSearchButtons = document.querySelectorAll('*[data-action="search-toggle"]');

    openSearchButtons.forEach((button) => {
        registerOpenSearchButton(button);
    });

    function registerOpenSearchButton(button){
        button.dataset.registered = true;
        button.addEventListener('click', (e) => {
            e.preventDefault();
            // Dispatch event to open cart
            window.dispatchEvent(new CustomEvent('search:open'));
        });
    }

    const closeSearchButtons = document.querySelectorAll('*[data-action="close-search"]');

    closeSearchButtons.forEach((button) => {
        registerCloseSearchButton(button);
    });

    function registerCloseSearchButton(button){
        button.dataset.registered = true;
        const overlay = button.closest('.Search_Popup')?.querySelector('.Overlay');
        button.addEventListener('click', (e) => {
            e.preventDefault();
            // Dispatch event to close search
            window.dispatchEvent(new CustomEvent('search:close'));
        });
        if(!overlay) return;
        overlay.addEventListener('click', (e) => {
            if(e.target === overlay){
                window.dispatchEvent(new CustomEvent('search:close'));
            }
        });
    }

    window.addEventListener("global:align", function(){
        const newOpenSearchButtons = document.querySelectorAll('*[data-action="search-toggle"]:not([data-registered])');
        const newCloseSearchButtons = document.querySelectorAll('*[data-action="close-search"]:not([data-registered])');

        newOpenSearchButtons.forEach((button) => {
            registerCloseSearchButton(button);
        });

        newCloseSearchButtons.forEach((button) => {
            registerOpenSearchButton(button);
        });
    });
});

// Setup listeners
const searchPopup = document.querySelector('#Search_Popup');

window.addEventListener('search:open', function() {
    openSearch();
});

window.addEventListener('search:close', function() {
    closeSearch();
});

function openSearch(){
    searchPopup.classList.add('Open');
}

function closeSearch(){
    searchPopup.classList.remove('Open');
}